"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A reason for closing the session
 */
var SessionCloseReason;
(function (SessionCloseReason) {
    SessionCloseReason[SessionCloseReason["CONNECTION_LOST"] = 0] = "CONNECTION_LOST";
    SessionCloseReason[SessionCloseReason["IO_EXCEPTION"] = 1] = "IO_EXCEPTION";
    SessionCloseReason[SessionCloseReason["CLIENT_UNRESPONSIVE"] = 2] = "CLIENT_UNRESPONSIVE";
    SessionCloseReason[SessionCloseReason["MESSAGE_QUEUE_LIMIT_REACHED"] = 3] = "MESSAGE_QUEUE_LIMIT_REACHED";
    SessionCloseReason[SessionCloseReason["CLOSED_BY_CLIENT"] = 4] = "CLOSED_BY_CLIENT";
    SessionCloseReason[SessionCloseReason["MESSAGE_TOO_LARGE"] = 5] = "MESSAGE_TOO_LARGE";
    SessionCloseReason[SessionCloseReason["INTERNAL_ERROR"] = 6] = "INTERNAL_ERROR";
    SessionCloseReason[SessionCloseReason["INVALID_INBOUND_MESSAGE"] = 7] = "INVALID_INBOUND_MESSAGE";
    SessionCloseReason[SessionCloseReason["ABORT"] = 8] = "ABORT";
    SessionCloseReason[SessionCloseReason["LOST_MESSAGES"] = 9] = "LOST_MESSAGES";
    SessionCloseReason[SessionCloseReason["SERVER_CLOSING"] = 10] = "SERVER_CLOSING";
    SessionCloseReason[SessionCloseReason["CLOSED_BY_CONTROLLER"] = 11] = "CLOSED_BY_CONTROLLER";
})(SessionCloseReason = exports.SessionCloseReason || (exports.SessionCloseReason = {}));



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/session-close-reason.js
// module id = 1292
// module chunks = 1